import React, { useEffect, useState } from 'react'
import EvidenceTable from './EvidenceTable'
import DraftTable from './DraftTable'
import '../../style/Views.scss'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import LeftPanel from './../Support/PageLeftPanel'
import { ReactComponent as EvidenceIcon } from '../../assets/images/Ev_Icon.svg'
import { ReactComponent as BeakerIcon } from '../../assets/images/beaker.svg'
import { useHistory } from 'react-router-dom'
import { isStrategySelected } from '../../utilities/helpers'
import store from '../../redux/store'
import { useAuth0 } from '../../contexts/auth0-context'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'

export default function Evidence() {
    const history = useHistory()
    const { getTokenSilently, isAuthenticated } = useAuth0()
    const [refreshKey, setRefreshKey] = useState(0)
    const [draftCount, setDraftCount] = useState(0)
    const [draftReviewOpen, setDraftReviewOpen] = useState(false)
    const [isNewDraft, setIsNewDraft] = useState(false)

    async function createNew(incomingData) {
        let result
        try {
            const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
            result = await callAPI(endpoints.createDraft.url, endpoints.createDraft.method, token, incomingData)
        } catch (err) {
            console.error('Failed to create draft:', err)
        }
        setRefreshKey((prev) => prev + 1)
        setIsNewDraft(true)
        return result?.data
    }

    const handleEvidenceImported = () => {
        setRefreshKey((prev) => prev + 1)
        setIsNewDraft(true)
    }

    // Fetch draft count for the current strategy
    useEffect(() => {
        const fetchDraftCount = async () => {
            if (!isAuthenticated) return
            const strategyId = store.getState().strategy._id
            if (!strategyId) return
            try {
                const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })
                const res = await callAPI(
                    endpoints.getDraftsByStrategyId.url + strategyId,
                    endpoints.getDraftsByStrategyId.method,
                    token
                )
                setDraftCount(res?.data?.length || 0)
            } catch (err) {
                console.error('Failed to fetch draft count:', err)
            }
        }
        fetchDraftCount()
    }, [refreshKey, isAuthenticated])

    // if no strategy selected, navigate to strategy selection page
    useEffect(() => {
        if (!isStrategySelected()) {
            history.push('/roadmaps')
        }
    })

    return (
        <Grid container item spacing={2} direction="column" sx={{ p: 2 }}>
            <LeftPanel
                imgsrc={draftReviewOpen ? BeakerIcon : EvidenceIcon}
                text={
                    draftReviewOpen
                        ? 'Evidence for Review'
                        : (store.getState() && store.getState().settings?.displayNames?.evidence) || 'Loading'
                }
                id={'evidence'}
                createNew={createNew}
                onEvidenceImported={handleEvidenceImported}
                //Pass 0 here to hide draft review button if the review is already open, otherwise pass the actual draft count
                draftCount={draftReviewOpen ? 0 : draftCount}
                isNewDraft={isNewDraft}
                showDraftStatusLegend={draftReviewOpen}
                onDraftReview={() => {
                    setDraftReviewOpen(true)
                    setIsNewDraft(false)
                }}
            />
            {draftReviewOpen ? (
                <>
                    <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Button
                            startIcon={<ArrowBackIosNewIcon />}
                            onClick={() => setDraftReviewOpen(false)}
                            variant="text"
                        >
                            Back to Evidence
                        </Button>
                    </Grid>
                    <DraftTable onDraftCountChange={(count) => setDraftCount(count)} refreshKey={refreshKey} />
                </>
            ) : (
                <EvidenceTable refreshKey={refreshKey} />
            )}
        </Grid>
    )
}
